import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./ordersummary.scss";

const OrderSummary = ({ orderDetail }) => {
  return (
    <div className="order-summary-desktop  custom-card-2 g-0 mt-3">
      <div className="vertical-separator p-3">
        <Row>
          <Col md={12} className="title fw-bold">
            ORDER SUMMARY
          </Col>
        </Row>
        <Row className="g-0 subtitle justify-content-between">
          <Col className="py-1">Subtotal</Col>
          <Col className="sub-total text-end">
            <span className="me-2 text-uppercase">
              {orderDetail.currency && orderDetail.currency}
            </span>
            <span className="">
              {orderDetail.total_price && orderDetail.total_price}
            </span>
          </Col>
        </Row>
        {orderDetail?.coupon_code && (
          <Row className="g-0 subtitle justify-content-between">
            <Col className="py-1">Coupon Code</Col>
            <Col className="sub-total text-end">{orderDetail?.coupon_code}</Col>
          </Row>
        )}
        {orderDetail.discount !== "0.0" && (
          <Row className="g-0 subtitle justify-content-between">
            <Col className="py-1">Discount</Col>

            <Col className="sub-total text-end">
              <span className="me-2 text-uppercase">
                {orderDetail.currency && orderDetail.currency}
              </span>
              <span className="">
                {orderDetail.discount && orderDetail.discount}
              </span>
            </Col>
          </Row>
        )}
        <Row
          className="g-0 subtitle justify-content-between"
          style={{ marginTop: "30px" }}
        >
          <Col className="py-1">
            <span
              className="fw-bold"
              style={{ color: "#404553", marginInlineEnd: "3px" }}
            >
              Total
            </span>
            <span>(Inclusive of VAT)</span>
          </Col>

          <Col className="sub-total text-end">
            <span className="me-2 text-uppercase">
              {orderDetail.currency && orderDetail.currency}
            </span>
            <span className="">
              {orderDetail?.total_price &&
                orderDetail.discount &&
                parseFloat(
                  ((orderDetail?.total_price - orderDetail?.discount) / 100) *
                    100
                )}
            </span>
          </Col>
        </Row>
        {orderDetail?.vat && (
          <Row className="g-0 subtitle justify-content-between">
            <Col className="py-1">Estimated VAT</Col>

            <Col className="text-end">
              <span className="me-2 text-uppercase">
                {orderDetail?.currency}
              </span>
              <span className="">{orderDetail?.vat}</span>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
